module.exports = __webpack_public_path__ + "static/data-127e9f39c1b3dcd97dfc5811b04cde79.svg";